import { BaseResource } from './BaseResource';
export class ProgramResource extends BaseResource {
    constructor(gl) {
        super(gl);
        this.resource = gl.createProgram();
    }
    delete() {
        this.gl.deleteProgram(this.resource);
    }
}
//# sourceMappingURL=ProgramResource.js.map